import React from 'react';
type EmptyPageProps = {
  title: string;
};
export function EmptyPage({
  title
}: EmptyPageProps) {
  return <section className="w-full bg-ink px-5 pb-24 pt-40 sm:px-8" data-id="element-203" data-mp="9gorvo7rxdev">
      <div className="mx-auto max-w-7xl" data-id="element-204" data-mp="4idifele54x6">
        <h1 className="font-display text-5xl font-bold tracking-tight text-white sm:text-7xl" data-id="element-205" data-mp="4jevtppvq3i2">{title}</h1>
      </div>
    </section>;
}